/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice } from '@reduxjs/toolkit';

import {
	type CommonState,
	commonReducers,
	initialCommonState,
} from '../_common/commonReducers';

// One slice serves every runtime table (`dynamicTables/{TableName}`) — the
// generic sagas resolve the raw table name back to this slice's actions.
const initialState: CommonState = {
	...initialCommonState,
};

const dynamicTablesSlice = createSlice({
	name: 'dynamicTables',
	initialState,
	reducers: {
		...commonReducers,
		// All runtime tables share this single slot, so the rows page must clear
		// the previous table's state BEFORE mounting a grid: a first fetch for
		// table B built from table A's structure sends wrong `fields` (backend
		// 400) and flashes A's columns/rows/preset into B's grid.
		resetTableState(): CommonState {
			return { ...initialCommonState };
		},
	},
});

export const {
	getTableStart,
	getTableSuccess,
	getTableFailure,
	getTableFinish,

	getItemStart,
	getItemSuccess,
	getItemFailure,

	createItemStart,
	createItemSuccess,
	createItemFailure,
	createItemFinish,

	updateItemStart,
	updateItemSuccess,
	updateItemFailure,
	updateItemFinish,

	deleteItemsStart,
	deleteItemsSuccess,
	deleteItemsFailure,
	deleteItemsFinish,

	deleteItemStart,
	deleteItemSuccess,
	deleteItemFailure,
	deleteItemFinish,

	getTableStructureStart,
	getTableStructureSuccess,
	getTableStructureFailure,

	getItemDocumentsStart,
	getItemDocumentsSuccess,
	getItemDocumentsFailure,
	getItemDocumentsFinish,

	uploadItemDocumentsStart,
	uploadItemDocumentsSuccess,
	uploadItemDocumentsFailure,
	uploadItemDocumentsFinish,

	deleteItemDocumentStart,
	deleteItemDocumentSuccess,
	deleteItemDocumentFailure,
	deleteItemDocumentFinish,

	getTableExcelStart,
	getTableExcelSuccess,
	getTableExcelFailure,
	getTableExcelFinish,

	resetTableState,
} = dynamicTablesSlice.actions;
export default dynamicTablesSlice;
